import i18n from "@/i18n"

export function getServiceName(key: string) {
    const validKeys = ['openingHours', 'pickupService', 'deliveryService', 'tableReservation']
    if (!validKeys.includes(key)) return ''
    return i18n.global.t(key)
}
